module.exports = __webpack_public_path__ + "static/img/screen_bg1.e067d4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bigScreen/screen_bg1.png
// module id = Q0WO
// module chunks = 1